const MAX_RETRIES = 6;

export default function useIntercomUpdate(data: Record<string, any>, retryCount = 0) {
    if (!window.Intercom) {
        if (retryCount < MAX_RETRIES) {
            setTimeout(() => useIntercomUpdate(data, retryCount + 1), 1000);
        }
        return;
    }

    window.Intercom('update', data);
}
